<template>
    <div class="qr-uploader-container d-flex flex-column"
        style="height: 100%; width: 100%; height: calc(100vh - 71px); overflow-y: auto;">

        <!-- Botón de volver solo cuando NO está en configuración de estudio -->
        <v-btn v-if="!showStudyConfig" class="back-button ma-3"
            style="position: fixed; top: 0; left: 0; z-index: 1000;" @click="back">
            <v-icon small class="mr-1">mdi-arrow-left</v-icon>
			<span class="font-rubik">Volver</span>
        </v-btn>

        <!-- Botón de reset al estado inicial (solo en configuración de estudio) -->
        <!-- <v-btn v-if="showStudyConfig" icon class="reset-button ma-3" style="position: fixed; top: 0; right: 0; z-index: 1000;"
            @click="resetToInitialState">
            <lucide-arrow-left :size="24" style="width: 24px; height: 24px;"></lucide-arrow-left>
        </v-btn> -->

        <!-- Contenido principal solo cuando NO está en configuración de estudio -->
        <div v-if="!showStudyConfig">
            <div style="max-width: 650px;" class="d-flex flex-column text-center align-center mx-auto pt-12">
                <h2 style="font-size: 24px;">Tomar fotos con móvil</h2>
                <span style="font-size: 16px;" class="my-2">Escanea el código QR con tu móvil para empezar a subir
                    fotos</span>
            </div>

            <div class="flex-grow-1 d-flex flex-column pa-4" style="margin: 0 auto; width: 100%;">

                <!-- Estado: Generando QR -->
                <div v-if="isGeneratingQR" class="qr-section d-flex flex-column align-center justify-center"
                    style="min-height: 400px;">
                    <v-progress-circular indeterminate color="primary" size="64" width="5"
                        class="mb-4"></v-progress-circular>
                    <h3 class="mb-2" style="font-weight: 500; font-size: 1.2rem;">Generando código QR...</h3>
                    <p class="text-body-2 grey--text text--darken-1">Por favor, espera un momento</p>
                </div>

                <!-- Estado: QR Generado -->
                <div v-else-if="qrData && !sessionExpired" class="qr-section d-flex flex-column align-center"
                    style="max-width: 1000px; margin: 0 auto; width: 100%;">

                    <!-- Código QR -->
                    <v-card class="qr-card pa-6" elevation="0" style="border-radius: 16px;">
                        <div class="qr-code-container d-flex flex-column align-center">
                            <canvas ref="qrCanvas" style="max-width: 250px; max-height: 250px;"></canvas>
                            <div class="mt-4 text-center">
                                <h3 style="font-weight: 600; color: #333;">📱 Escanea con tu móvil</h3>
                                <p class="text-body-2 grey--text mt-2">Abre la cámara de tu móvil y escanea este código
                                </p>
                            </div>
                        </div>
                    </v-card>

                    <!-- Información de la sesión -->
                    <v-card v-if="false" class="session-info-card pa-4 my-4" elevation="0"
                        style="border-radius: 12px; width: 100%; max-width: 400px;">
                        <div class="d-flex justify-space-between align-center">
                            <span style="font-weight: 600;">📸 Fotos subidas:</span>
                            <v-chip color="primary" text-color="white" small>{{ photoCount }}</v-chip>
                        </div>

                        <div v-if="false" class="d-flex justify-space-between align-center mt-2">
                            <span style="font-weight: 600;">⏱️ Tiempo restante:</span>
                            <span :class="timeRemaining < 300 ? 'error--text' : 'success--text'"
                                style="font-weight: 600;">
                                {{ formatTime(timeRemaining) }}
                            </span>
                        </div>

                        <div v-if="false" class="d-flex justify-space-between align-center">
                            <span style="font-weight: 600;">🔗 Estado:</span>
                            <v-chip :color="sessionStatus === 'active' ? 'success' : 'warning'" text-color="white"
                                small>
                                {{ sessionStatusText }}
                            </v-chip>
                        </div>
                    </v-card>

                    <!-- Instrucciones -->
                    <v-card class="instructions-card pa-4 mt-4" elevation="0"
                        style="border-radius: 12px; background-color: #f8f9fa; width: 100%; max-width: 500px;">
                        <h4 class="mb-2" style="font-weight: 600; color: #333;">📋 Instrucciones:</h4>
                        <ol class="text-body-2" style="color: #666; line-height: 1.6;">
                            <li>Escanea el código QR con la cámara de tu móvil</li>
                            <li>Se abrirá una página web para subir imagenes con el móvil</li>
                            <li>Toma o sube las fotos que necesites</li>
                            <li>Las fotos aparecerán aquí en tiempo real</li>
                            <li>Cuando termines, haz clic en "Procesar fotos"</li>
                        </ol>
                    </v-card>

                    <!-- Fotos en tiempo real -->
                    <div v-if="photos.length > 0" class="photos-preview-card mt-12"
                        style="width: 100%; max-width: 1000px;">
                        <v-card class="pa-4" elevation="0" style="border-radius: 12px;">
                            <PhotoGrid :photos="photos" :session-id="sessionId" @photo-click="openImageDialog"
                                @delete-photo="deletePhoto" @photos-reordered="onPhotosReordered"
                                @drag-end="onDragEnd" @delete-all-photos="deleteAllPhotos" />
                        </v-card>
                    </div>

                </div>

                <!-- Estado: Sesión Expirada -->
                <div v-else-if="sessionExpired" class="expired-section d-flex flex-column align-center justify-center"
                    style="min-height: 400px;">
                    <v-icon size="64" color="error" class="mb-4">mdi-clock-alert-outline</v-icon>
                    <h3 class="mb-2" style="font-weight: 500; font-size: 1.2rem; color: #d32f2f;">Sesión expirada</h3>
                    <p class="text-body-2 grey--text text--darken-1 mb-4">La sesión QR ha expirado. Genera un nuevo
                        código
                        para continuar.</p>
                    <v-btn color="primary" @click="generateQR" :loading="isGeneratingQR">
                        Generar nuevo QR
                    </v-btn>
                </div>

                <!-- Estado: Error -->
                <div v-else-if="error" class="error-section d-flex flex-column align-center justify-center"
                    style="min-height: 400px;">
                    <v-icon size="64" color="error" class="mb-4">mdi-alert-circle-outline</v-icon>
                    <h3 class="mb-2" style="font-weight: 500; font-size: 1.2rem; color: #d32f2f;">Error</h3>
                    <p class="text-body-2 grey--text text--darken-1 mb-4">{{ error }}</p>
                    <v-btn color="primary" @click="generateQR" :loading="isGeneratingQR">
                        Intentar de nuevo
                    </v-btn>
                </div>

            </div>

            <!-- Botón fijo para procesar fotos -->
            <div v-if="photos.length > 0 && !sessionExpired" class="pa-4 d-flex justify-end fixed-button-container"
                style="border-top: 1px solid #dedede; margin: 0 auto; width: 100%;">
                <v-btn depressed color="primary" class="primary-btn" @click="processPhotos" :loading="isProcessing"
                    :disabled="isProcessing || photos.length === 0">
                    Procesar {{ photos.length }} {{ photos.length === 1 ? 'foto' : 'fotos' }}
                </v-btn>
            </div>
        </div>

        <!-- Sección de configuración de estudio -->
        <div v-if="showStudyConfig" class="study-config-section">
            <div style="max-width: 650px; min-height: calc(100vh - 80px);"
                class="d-flex flex-column text-center align-center mx-auto pt-4">
                <div v-if="generatedDocument" class="d-flex flex-column text-center align-center mx-auto pt-4">
                    <h2 style="font-size: 24px;">Configuración del estudio</h2>
                    <span style="font-size: 16px;" class="my-2">Escoge el lenguaje y los tipos de preguntas.</span>

                    <!-- Document Preview -->
                    <div v-if="generatedDocument" class="mt-4 mb-6 text-left"
                        style="width: 100%; border: 1px solid #e0e0e0; border-radius: 8px; padding: 12px; max-width: 350px;">
                        <div class="d-flex align-center mx-auto">
                            <!-- PDF Icon -->
                            <div class="preview-container mr-3" style="width: 40px; height: 40px;">
                                <div class="d-flex align-center justify-center" style="width: 100%; height: 100%;">
                                    <lucide-file-text :size="24" color="#dc3545"></lucide-file-text>
                                </div>
                            </div>
                            <!-- File Info -->
                            <div class="d-flex flex-column" style="overflow: hidden; flex: 1;">
                                <div class="text-truncate document-name" :title="generatedDocument.fileName">{{
                                    generatedDocument.fileName }}</div>
                                <div style="font-size: 12px;" class="grey--text">{{ generatedDocument.photoCount }} {{
                                    generatedDocument.photoCount === 1 ? 'foto' : 'fotos' }}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Study Configurator Component -->
                <study-configurator ref="studyConfig" :detected-language.sync="detectedLanguage"
                    :selected-subject-prop.sync="selectedSubject"
                />
            </div>

            <!-- Botones del configurador -->
            <div class="d-flex justify-space-between align-center mt-4"
                style="position: fixed; bottom: 0; left: 0; right: 0; background-color: white; padding: 16px; border-top: 1px solid #E3E5EB;">
                <v-btn text @click="backToPhotos">
                    <lucide-arrow-left :size="16" class="mr-1" style="width: 16px; height: 16px;"></lucide-arrow-left>
                    Volver
                </v-btn>
                <v-spacer></v-spacer>

                <v-btn color="primary" class="primary-btn" @click="generateFinalContent"
                    :disabled="isGeneratingFinalContent || !detectedLanguage || !selectedSubject"
                    :loading="isGeneratingFinalContent">
                    <span>{{ isGeneratingFinalContent ? 'Generando...' : 'Generar materiales' }}</span>
                    <lucide-arrow-right :size="16" class="ml-1"></lucide-arrow-right>
                </v-btn>
            </div>
        </div>

        <!-- Dialog de procesamiento -->
        <v-dialog v-model="showProcessingDialog" persistent max-width="400">
            <v-card>
                <v-card-title class="text-h5 text-center pa-4">
                    Procesando fotos
                </v-card-title>
                <v-card-text class="text-center">
                    <v-progress-circular indeterminate color="primary" size="64" width="5"
                        class="mb-4"></v-progress-circular>
                    <p class="mt-4">Estamos convirtiendo tus fotos en un documento PDF y generando materiales de
                        estudio...</p>
                </v-card-text>
            </v-card>
        </v-dialog>

        <!-- Dialog de imagen grande -->
        <v-dialog v-model="showImageDialog" max-width="90vw" max-height="90vh">
            <v-card class="image-dialog-card">
                <v-card-title class="pa-2 d-flex justify-space-between align-center">
                    <span class="text-h6">Foto {{ currentImageIndex + 1 }} de {{ photos.length }}</span>
                    <div class="d-flex align-center" style="gap: 8px;">
                        <v-btn icon color="error" @click="deleteCurrentPhoto" :disabled="!currentPhoto">
                            <v-icon>mdi-delete</v-icon>
                        </v-btn>
                        <v-btn icon @click="showImageDialog = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </div>
                </v-card-title>

                <v-card-text class="pa-0 position-relative">
                    <div class="image-container d-flex align-center justify-center"
                        style="min-height: 400px; max-height: 70vh; overflow: hidden;">
                        <!-- Botón anterior -->
                        <v-btn v-if="photos.length > 1" icon large class="nav-button nav-button-left"
                            @click="previousImage" :disabled="currentImageIndex === 0"
                            style="position: absolute; left: 16px; z-index: 10; background-color: rgba(0,0,0,0.5);">
                            <v-icon color="white">mdi-chevron-left</v-icon>
                        </v-btn>

                        <!-- Imagen principal -->
                        <img v-if="currentPhoto" :src="getPhotoUrl(currentPhoto.id)" :alt="`Foto ${currentPhoto.order}`"
                            class="dialog-image" style="max-width: 100%; max-height: 70vh; object-fit: contain;" />

                        <!-- Botón siguiente -->
                        <v-btn v-if="photos.length > 1" icon large class="nav-button nav-button-right"
                            @click="nextImage" :disabled="currentImageIndex === photos.length - 1"
                            style="position: absolute; right: 16px; z-index: 10; background-color: rgba(0,0,0,0.5);">
                            <v-icon color="white">mdi-chevron-right</v-icon>
                        </v-btn>
                    </div>

                    <!-- Indicadores de navegación -->
                    <div v-if="photos.length > 1" class="navigation-dots d-flex justify-center pa-3" style="gap: 8px;">
                        <v-btn v-for="(photo, index) in photos" :key="photo.id" icon x-small
                            :color="index === currentImageIndex ? 'primary' : 'grey'" @click="goToImage(index)">
                            <v-icon small>mdi-circle</v-icon>
                        </v-btn>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>

    </div>
</template>

<script>
import { ArrowLeft, Image, FileText, ArrowUp } from 'lucide-vue'
import QRCode from 'qrcode'
import axios from 'axios'
import draggable from 'vuedraggable'
import PhotoGrid from './PhotoGrid.vue'
import StudyConfigurator from './StudyConfigurator.vue'

export default {
    name: 'QRUploader',
    components: {
        LucideArrowLeft: ArrowLeft,
        LucideImage: Image,
        LucideFileText: FileText,
        LucideArrowUp: ArrowUp,
        draggable,
        PhotoGrid,
        StudyConfigurator
    },
    props: {
        subjectId: {
            type: [Number, String],
            default: null
        }
    },
    data() {
        return {
            isGeneratingQR: false,
            qrData: null,
            sessionId: null,
            photos: [],
            photoCount: 0,
            timeRemaining: 0,
            sessionStatus: 'active',
            sessionExpired: false,
            error: null,
            isProcessing: false,
            showProcessingDialog: false,

            // Polling
            statusInterval: null,
            timeInterval: null,

            showImageDialog: false,
            currentImageIndex: 0,

            // Nuevas propiedades para el flujo de StudyConfigurator
            showStudyConfig: false,
            generatedDocument: null,
            isGeneratingFinalContent: false,
            detectedLanguage: null,
            selectedSubject: null
        }
    },
    computed: {
        sessionStatusText() {
            switch (this.sessionStatus) {
                case 'active': return 'Activa'
                case 'completed': return 'Completada'
                case 'expired': return 'Expirada'
                default: return 'Desconocido'
            }
        },

        currentPhoto() {
            return this.photos[this.currentImageIndex] || null
        },
    },
    mounted() {
        // Verificar que tenemos un token de sesión antes de generar el QR
        // if (!this.$root.token || !this.$root.token.value) {
        // this.error = 'No hay sesión activa. Por favor, inicia sesión.'
        // return
        // }
        // 

        if (this.$route.query.sessionId) {
            this.loadExistingSession(this.$route.query.sessionId)
        } else {
            this.generateQR()
        }

    },
    beforeDestroy() {
        this.clearIntervals()
        this.removeKeyboardListeners()
    },
    watch: {
        showImageDialog(newVal) {
            if (newVal) {
                this.addKeyboardListeners()
            } else {
                this.removeKeyboardListeners()
            }
        }
    },
    methods: {
        async generateQR() {
            // Verificar que tenemos un token válido
            if (!this.$root.token || !this.$root.token.value) {
                this.error = 'No hay sesión activa. Por favor, inicia sesión.'
                this.isGeneratingQR = false
                return
            }

            this.isGeneratingQR = true
            this.error = null
            this.sessionExpired = false
            this.clearIntervals()


            try {
                const response = await axios.post('/qr-upload/create-session', {
                    userId: this.$root.currentUser.userId
                }, {
                    headers: {
                        Authorization: this.$root.token.value
                    }
                })

                if (response.data.success) {
                    this.qrData = response.data
                    this.sessionId = response.data.sessionId

                    await this.$router.replace({
                        query: { ...this.$route.query, sessionId: this.sessionId }
                    })
                    this.timeRemaining = 7 * 24 * 60 * 60 // 7 días en segundos

                    console.log('QR Data received:', response.data)
                    console.log('QR URL:', response.data.qrUrl)

                    // Generar QR visual
                    setTimeout(async () => {
                        await this.renderQR(response.data.qrUrl)

                        // Iniciar polling
                        this.startPolling()
                    }, 200)

                    // this.$toast.success('Código QR generado. ¡Escanéalo con tu móvil!')
                } else {
                    this.error = response.data.error || 'Error generando código QR'
                }
            } catch (error) {
                console.error('Error generando QR:', error)
                if (error.response && error.response.status === 401) {
                    this.error = 'Sesión expirada. Por favor, inicia sesión nuevamente.'
                } else {
                    this.error = 'Error de conexión. Inténtalo de nuevo.'
                }
            } finally {
                this.isGeneratingQR = false
            }
        },

        back() {
            if (this.photos.length === 0) {
                this.$emit('back')
            } else {
                this.photos.forEach(photo => {
                    this.deletePhotoFromServer(photo)
                })
                // this.photos = []
                // this.photoCount = 0
                // this.sessionStatus = 'active'
                // this.sessionExpired = false
            }
        },

        async renderQR(url) {
            try {
                console.log('Rendering QR for URL:', url)
                await this.$nextTick() // Asegurar que el canvas esté en el DOM

                if (this.$refs.qrCanvas) {
                    console.log('Canvas found, generating QR...')
                    await QRCode.toCanvas(this.$refs.qrCanvas, url, {
                        width: 250,
                        margin: 2,
                        color: {
                            dark: '#000000',
                            light: '#FFFFFF'
                        }
                    })
                    console.log('QR generated successfully')
                } else {
                    console.error('Canvas not found in refs')
                }
            } catch (error) {
                console.error('Error renderizando QR:', error)
                this.error = 'Error generando código QR visual'
            }
        },

        startPolling() {
            // Polling para estado de sesión y fotos cada 2 segundos
            this.statusInterval = setInterval(() => {
                this.checkSessionStatus()
            }, 2000)

            // Countdown timer cada segundo
            this.timeInterval = setInterval(() => {
                if (this.timeRemaining > 0) {
                    this.timeRemaining--
                } else {
                    this.sessionExpired = true
                    this.clearIntervals()
                }
            }, 1000)
        },

        async checkSessionStatus() {
            if (!this.sessionId) return

            // Verificar que tenemos un token válido
            if (!this.$root.token || !this.$root.token.value) {
                this.error = 'No hay sesión activa. Por favor, inicia sesión.'
                this.clearIntervals()
                return
            }

            try {
                const response = await axios.get(`/qr-upload/session-status/${this.sessionId}`, {
                    headers: {
                        Authorization: this.$root.token.value
                    }
                })

                if (response.data.success) {
                    const { session, photos, photoCount } = response.data

                    this.sessionStatus = session.status
                    this.photos = photos
                    this.photoCount = photoCount

                    // Si la sesión está completada o expirada, parar polling
                    if (session.status === 'completed' || session.status === 'expired') {
                        this.clearIntervals()
                        if (session.status === 'expired') {
                            this.sessionExpired = true
                        }
                    }
                
                }
            } catch (error) {
                console.error('Error checking session status:', error)
                if (error.response && error.response.status === 401) {
                    this.error = 'Sesión expirada. Por favor, inicia sesión nuevamente.'
                    this.clearIntervals()
                }
                // No mostrar otros errores aquí para no interrumpir la experiencia
            }
        },

        clearIntervals() {
            if (this.statusInterval) {
                clearInterval(this.statusInterval)
                this.statusInterval = null
            }
            if (this.timeInterval) {
                clearInterval(this.timeInterval)
                this.timeInterval = null
            }
        },

        formatTime(seconds) {
            const minutes = Math.floor(seconds / 60)
            const remainingSeconds = seconds % 60
            return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`
        },

        async processPhotos() {
            if (this.photos.length === 0) return

            this.isProcessing = true
            this.showProcessingDialog = true

            try {
                // Verificar que tenemos un token válido
                if (!this.$root.token || !this.$root.token.value) {
                    this.$toast.error('No hay sesión activa. Por favor, inicia sesión.');
                    return;
                }

                // Llamar al nuevo endpoint para procesar las fotos y generar el PDF
                const response = await axios.post(`/mobile-upload/process-photos/${this.qrData.token}`, {
                    user_id: this.$root.currentUser.userId,
                    selectedSubject: this.subjectId,
                    community_id: this.$root.currentUser.educationInfo.education.community_id
                }, {
                    headers: {
                        Authorization: this.$root.token.value
                    }
                });

                if (response.data.success) {
                    // Mostrar el StudyConfigurator
                    this.showStudyConfig = true;
                    this.generatedDocument = {
                        documentId: response.data.documentId,
                        fileName: response.data.fileName,
                        photoCount: response.data.photoCount
                    };

                    // this.$toast.success(`¡PDF generado con ${response.data.photoCount} fotos!`);
                } else {
                    this.$toast.error('Error procesando las fotos: ' + (response.data.error || ''));
                }

            } catch (error) {
                console.error('Error procesando fotos:', error);
                if (error.response && error.response.status === 401) {
                    this.$toast.error('Sesión expirada. Por favor, inicia sesión nuevamente.');
                } else {
                    this.$toast.error('Error procesando las fotos. Inténtalo de nuevo.');
                }
            } finally {
                this.isProcessing = false
                this.showProcessingDialog = false
            }
        },

        getPhotoUrl(photoId) {
            return process.env.VUE_APP_AXIOS_URI + `/qr-upload/image/${this.sessionId}/${photoId}`
        },

        openImageDialog(photo) {
            this.currentImageIndex = this.photos.findIndex(p => p.id === photo.id)
            this.showImageDialog = true
        },

        previousImage() {
            if (this.currentImageIndex > 0) {
                this.currentImageIndex--
            }
        },

        nextImage() {
            if (this.currentImageIndex < this.photos.length - 1) {
                this.currentImageIndex++
            }
        },

        goToImage(index) {
            if (index >= 0 && index < this.photos.length) {
                this.currentImageIndex = index
            }
        },

        addKeyboardListeners() {
            document.addEventListener('keydown', this.handleKeydown)
        },

        removeKeyboardListeners() {
            document.removeEventListener('keydown', this.handleKeydown)
        },

        handleKeydown(event) {
            if (!this.showImageDialog) return

            switch (event.key) {
                case 'ArrowLeft':
                    event.preventDefault()
                    this.previousImage()
                    break
                case 'ArrowRight':
                    event.preventDefault()
                    this.nextImage()
                    break
                case 'Escape':
                    event.preventDefault()
                    this.showImageDialog = false
                    break
            }
        },

        deletePhoto(photo) {
            if (confirm(`¿Estás seguro de que quieres eliminar la foto ${photo.order}?`)) {
                // Llamar al API para eliminar la foto
                this.deletePhotoFromServer(photo)
            }
        },

        async deletePhotoFromServer(photo) {
            // Verificar que tenemos un token válido
            if (!this.$root.token || !this.$root.token.value) {
                this.$toast.error('No hay sesión activa. Por favor, inicia sesión.')
                return
            }

            try {
                const response = await axios.delete(`/qr-upload/photo/${this.sessionId}/${photo.id}`, {
                    headers: {
                        Authorization: this.$root.token.value
                    }
                })

                if (response.data.success) {
                    // Remover la foto de la lista local
                    this.photos = this.photos.filter(p => p.id !== photo.id)
                    this.photoCount = this.photos.length

                    // Si estamos viendo esta foto en el diálogo, cerrarlo o cambiar a otra
                    if (this.showImageDialog && this.currentPhoto && this.currentPhoto.id === photo.id) {
                        if (this.photos.length === 0) {
                            this.showImageDialog = false
                        } else {
                            // Ajustar el índice si es necesario
                            if (this.currentImageIndex >= this.photos.length) {
                                this.currentImageIndex = this.photos.length - 1
                            }
                        }
                    }

                    // this.$toast.success('Foto eliminada correctamente')
                } else {
                    this.$toast.error('Error eliminando la foto')
                }
            } catch (error) {
                console.error('Error eliminando foto:', error)
                if (error.response && error.response.status === 401) {
                    this.$toast.error('Sesión expirada. Por favor, inicia sesión nuevamente.')
                    this.error = 'Sesión expirada. Por favor, inicia sesión nuevamente.'
                } else {
                    this.$toast.error('Error de conexión al eliminar la foto')
                }
            }
        },

        onDragEnd() {
            // Actualizar el orden en el servidor
            this.updatePhotoOrder()
        },

        async updatePhotoOrder() {
            // Verificar que tenemos un token válido
            if (!this.$root.token || !this.$root.token.value) {
                console.error('No hay token de sesión para actualizar el orden')
                // Recargar fotos en caso de error
                this.checkSessionStatus()
                return
            }

            try {
                const photoOrder = this.photos.map((photo, index) => ({
                    id: photo.id,
                    order: index + 1
                }))

                const response = await axios.put(`/qr-upload/update-order/${this.sessionId}`, {
                    photos: photoOrder
                }, {
                    headers: {
                        Authorization: this.$root.token.value
                    }
                })

                if (response.data.success) {
                    // Actualizar el orden local con la respuesta del servidor
                    this.photos = this.photos.map((photo, index) => ({
                        ...photo,
                        order: index + 1
                    }))
                } else {
                    console.error('Error actualizando orden:', response.data.error)
                    // Recargar fotos en caso de error
                    this.checkSessionStatus()
                }
            } catch (error) {
                console.error('Error actualizando orden de fotos:', error)
                if (error.response && error.response.status === 401) {
                    this.error = 'Sesión expirada. Por favor, inicia sesión nuevamente.'
                    this.clearIntervals()
                }
                // Recargar fotos en caso de error
                this.checkSessionStatus()
            }
        },

        deleteCurrentPhoto() {
            if (this.currentPhoto) {
                this.deletePhoto(this.currentPhoto)
            }
        },

        onPhotosReordered(newPhotos) {
            this.photos = newPhotos
        },

        async loadExistingSession(sessionId) {
            // Verificar que tenemos un token válido
            if (!this.$root.token || !this.$root.token.value) {
                this.error = 'No hay sesión activa. Por favor, inicia sesión.'
                return
            }

            this.isGeneratingQR = true
            this.error = null
            this.sessionExpired = false
            this.clearIntervals()

            try {
                const response = await axios.get(`/qr-upload/session-status/${sessionId}`, {
                    headers: {
                        Authorization: this.$root.token.value
                    }
                })

                if (response.data.success) {
                    const { session, photos, photoCount } = response.data

                    // Verificar si la sesión está expirada
                    if (session.status === 'expired') {
                        this.sessionExpired = true
                        this.isGeneratingQR = false
                        return
                    }

                    // Configurar datos de la sesión
                    this.sessionId = sessionId
                    this.sessionStatus = session.status
                    this.photos = photos
                    this.photoCount = photoCount

                    // Calcular tiempo restante
                    const expiresAt = new Date(session.expiresAt)
                    const now = new Date()
                    this.timeRemaining = Math.max(0, Math.floor((expiresAt - now) / 1000))

                    // Crear datos QR para mostrar el código
                    this.qrData = {
                        sessionId: sessionId,
                        token: session.token,
                        qrUrl: session.qrUrl
                    }

                    console.log("session status", session.status)
                    console.log("time remaining", this.timeRemaining)

                    if (session.status === 'completed' && this.timeRemaining > 0) {
                        // Reactivar la sesión si está completada pero aún hay tiempo
                        await this.reactivateSession()
                    }

                    // Renderizar QR si la sesión está activa
                    if ((session.status === 'active') && this.timeRemaining > 0) {
                        setTimeout(async () => {
                            await this.renderQR(this.qrData.qrUrl)
                            // Iniciar polling
                            this.startPolling()
                        }, 200)
                    } else if (session.status === 'completed') {
                        // Si está completada, solo mostrar las fotos sin QR
                        this.clearIntervals()
                    }

                } else {
                    this.error = response.data.error || 'Error cargando la sesión'
                }
            } catch (error) {
                console.error('Error cargando sesión existente:', error)
                if (error.response && error.response.status === 401) {
                    this.error = 'Sesión expirada. Por favor, inicia sesión nuevamente.'
                } else if (error.response && error.response.status === 404) {
                    this.error = 'Sesión no encontrada.'
                } else {
                    this.error = 'Error de conexión. Inténtalo de nuevo.'
                }
            } finally {
                this.isGeneratingQR = false
            }
        },

        async generateFinalContent() {
            if (!this.generatedDocument) {
                this.$toast.error('Error: No hay documento disponible.');
                return;
            }

            this.isGeneratingFinalContent = true;

            try {
                // Asegurar que el componente esté completamente montado
                await this.$nextTick();

                if (!this.$refs.studyConfig) {
                    this.$toast.error('Error: Configuración no disponible.');
                    this.isGeneratingFinalContent = false;
                    return;
                }

                // const config = this.$refs.studyConfig.getConfig();
                const config = {
                    selectedLanguage: this.detectedLanguage,
                    selectedQuestionTypes: ['multiple_choice', 'true_false'],
                    selectedSubject: this.selectedSubject
                }

                if (!config || !config.selectedLanguage || !config.selectedQuestionTypes) {
                    this.$toast.error('Por favor, selecciona el idioma y los tipos de preguntas.');
                    this.isGeneratingFinalContent = false;
                    return;
                }

                try {
                    // Asignar documento a la asignatura si se seleccionó una
                    if (config.selectedSubject) {
                        await this.$refs.studyConfig.assignDocumentToSubject(this.generatedDocument.documentId);
                    }

                    this.$toast.success('¡Materiales de estudio generados correctamente!');

                    // Redirigir al documento
                    this.$router.push(`/app/document/${this.generatedDocument.documentId}?language=${config.selectedLanguage}`);
                } catch (error) {
                    this.$toast.error('Error generando los materiales de estudio.');
                }

            } catch (error) {
                console.error('Error en generación final:', error);
                if (error.response && error.response.status === 401) {
                    this.$toast.error('Sesión expirada. Por favor, inicia sesión nuevamente.');
                } else {
                    this.$toast.error('Error generando los materiales. Inténtalo de nuevo.');
                }
            } finally {
                this.isGeneratingFinalContent = false;
            }
        },

        backToPhotos() {
            this.showStudyConfig = false;
            this.generatedDocument = null;
            // Opcional: limpiar las fotos si se quiere empezar de nuevo
            // this.photos = [];
        },

        resetToInitialState() {
            this.showStudyConfig = false;
            this.generatedDocument = null;
            this.photos = [];
            this.photoCount = 0;
            this.timeRemaining = 0;
            this.sessionStatus = 'active';
            this.sessionExpired = false;
            this.error = null;
            this.isGeneratingQR = false;
            this.qrData = null;
            this.sessionId = null;
            this.currentImageIndex = 0;
            this.showImageDialog = false;
            this.isProcessing = false;
            this.showProcessingDialog = false;
            this.isGeneratingFinalContent = false;
            this.detectedLanguage = null;
            this.clearIntervals();
        },

        async deleteAllPhotos() {
            // Eliminar todas las fotos del servidor
            const deletePromises = this.photos.map(photo => 
                this.deletePhotoFromServer(photo)
            );
            
            try {
                await Promise.all(deletePromises);
                // Las fotos se van eliminando de la lista local en deletePhotoFromServer
                // this.$toast.success('Todas las fotos han sido eliminadas');

                this.generateQR()
            } catch (error) {
                console.error('Error eliminando todas las fotos:', error);
                this.$toast.error('Error eliminando algunas fotos');
            }
        },

        async reactivateSession() {
            if (!this.sessionId) return

            // Verificar que tenemos un token válido
            if (!this.$root.token || !this.$root.token.value) {
                this.error = 'No hay sesión activa. Por favor, inicia sesión.'
                return
            }

            try {
                const response = await axios.put(`/qr-upload/reactivate-session/${this.sessionId}`, {}, {
                    headers: {
                        Authorization: this.$root.token.value
                    }
                })

                if (response.data.success) {
                    // Actualizar el estado local
                    this.sessionStatus = 'active'
                    
                    // Renderizar QR y empezar polling
                    setTimeout(async () => {
                        await this.renderQR(this.qrData.qrUrl)
                        // Iniciar polling
                        this.startPolling()
                    }, 200)

                    console.log('Sesión reactivada correctamente')
                } else {
                    console.error('Error reactivando sesión:', response.data.error)
                }
            } catch (error) {
                console.error('Error reactivando sesión:', error)
                if (error.response && error.response.status === 401) {
                    this.error = 'Sesión expirada. Por favor, inicia sesión nuevamente.'
                }
            }
        }
    }
}
</script>

<style scoped>
.qr-uploader-container {
    background-color: white;
    position: relative;
    padding-bottom: 70px;
    /* Espacio para el botón fijo */
}

.qr-card {
    background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
    border: 1px solid #e9ecef;
}

.session-info-card {
    background-color: #f8f9fa;
    border: 1px solid #e9ecef;
}

.instructions-card {
    border: 1px solid #e9ecef;
}

.photos-grid {
    overflow-y: hidden;
}

.photo-card {
    transition: transform 0.2s ease;
    cursor: grab;
}

.photo-card:hover {
    transform: scale(1.05);
}

.photo-card:active {
    cursor: grabbing;
}

/* Vue.Draggable classes */
.ghost {
    opacity: 0.3;
    background: rgba(77, 212, 83, 0.2);
    border: 2px dashed #4dd453;
    transform: scale(0.95);
}

.chosen {
    transform: scale(1.1);
    box-shadow: 0 4px 12px rgba(77, 212, 83, 0.3);
}

.drag {
    opacity: 0.9;
    transform: rotate(2deg) scale(1.05);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
}

.delete-button {
    opacity: 1;
    transition: all 0.2s ease;
}

.delete-button:hover {
    background-color: rgba(220, 53, 69, 1) !important;
    transform: scale(1.1);
}

.primary-btn {
    text-transform: none !important;
    letter-spacing: 0 !important;
    font-weight: 800 !important;
    font-size: 0.9rem !important;
    border-radius: 13px !important;
    transition: filter 0.2s ease, transform 0.1s ease !important;
    height: 38px !important;
    max-height: 38px !important;
    padding-left: 24px !important;
    padding-right: 24px !important;
    border: 2px solid #4dd453 !important;
    background-color: #4dd453 !important;
    box-shadow: 0 4px 0 #42b848 !important;
    color: white !important;
}

.primary-btn:hover {
    filter: brightness(1.02);
    transform: translateY(0) !important;
}

.primary-btn:active {
    box-shadow: 0 0 0 #42b848 !important;
    transform: translateY(4px) !important;
}

.primary-btn:disabled {
    border: 2px solid #E0E0E0 !important;
    box-shadow: 0 4px 0 #9a9a9a !important;
}

.fixed-button-container {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: white;
    z-index: 10;
}

.qr-code-container canvas {
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.photo-image.loaded {
    opacity: 1 !important;
}

.image-dialog-card {
    border-radius: 12px !important;
}

.nav-button {
    transition: all 0.2s ease;
}

.nav-button:hover {
    background-color: rgba(0, 0, 0, 0.7) !important;
    transform: scale(1.1);
}

.nav-button:disabled {
    background-color: rgba(0, 0, 0, 0.3) !important;
}

.dialog-image {
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.navigation-dots .v-btn:hover {
    transform: scale(1.2);
}

.study-config-section {
    background-color: white;
    min-height: 100vh;
}

.preview-container {
    border-radius: 8px;
    background-color: #f5f5f5;
    display: flex;
    align-items: center;
    justify-content: center;
}

.document-name {
    font-weight: 600;
    font-size: 14px;
    color: #333;
}

.reset-button {
    background-color: rgba(255, 255, 255, 0.9) !important;
    backdrop-filter: blur(10px);
    transition: all 0.2s ease;
    border: 1px solid #e0e0e0;
}

.reset-button:hover {
    background-color: rgba(255, 255, 255, 1) !important;
    transform: scale(1.05);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}
</style>